import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TNavigationState } from './navigation.models';

export const selectNavigation = createFeatureSelector<TNavigationState>('navigationInfo');

export const selectNavigationItem = createSelector(selectNavigation, (navigationInfo) => {
  return navigationInfo.selectedNavigationItem;
});

export const getCustomPageHeader = createSelector(selectNavigation, (navigationInfo) => {
  return navigationInfo.customPageHeader;
});
